<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card" v-if="$gate.isAdmin() || $gate.isIren()">
                        <div class="card-header">
                            <h3 class="card-title">Evse List</h3>
                            <div class="card-tools">
                                <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                                    <i class="fa fa-plus-square"></i>
                                    Add New
                                </button>
                            </div>
                        </div>
                        <!-- /.card-header -->
                        <div class="card-body table-responsive p-0">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th>id</th>
                                    <th>created_at</th>
                                    <th>updated_at</th>
                                    <th>status</th>
                                    <th>status_schedule</th>
                                    <th>capabilities</th>
                                    <th>connectors</th>
                                    <th>floor_level</th>
                                    <th>coordinates</th>
                                    <th>physical_reference</th>
                                    <th>directions</th>
                                    <th>parking_restrictions</th>
                                    <th>images</th>
                                    <th>last_updated</th>
                                    <th>label</th>
                                    <th>ocpp_evse_id</th>
                                    <th>charging_station</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="evse in Evses" :key="Evses.id">
                                    <td class="text-capitalize">{{ evse.id }}</td>
                                    <td class="text-capitalize">{{ formatDate(evse.created_at) }}</td>
                                    <td class="text-capitalize">{{ formatDate(evse.updated_at) }}</td>
                                    <td class="text-capitalize">{{ evse.status }}</td>
                                    <td class="text-capitalize">{{ evse.status_schedule }}</td>
                                    <td class="text-capitalize">{{ evse.capabilities }}</td>
                                    <td class="text-capitalize">{{ evse.connectors }}</td>
                                    <td class="text-capitalize">{{ evse.floor_level }}</td>
                                    <td class="text-capitalize">{{ evse.coordinates }}</td>
                                    <td class="text-capitalize">{{ evse.physical_reference }}</td>
                                    <td class="text-capitalize">{{ evse.directions }}</td>
                                    <td class="text-capitalize">{{ evse.parking_restrictions }}</td>
                                    <td class="text-capitalize">{{ evse.images }}</td>
                                    <td class="text-capitalize">{{ evse.last_updated }}</td>
                                    <td class="text-capitalize">{{ evse.label }}</td>
                                    <td class="text-capitalize">{{ evse.ocpp_evse_id }}</td>
                                    <td class="text-capitalize">{{ evse.charging_station }}</td>
                                    <td>
                                        <a href="#" @click="editModal(evse)">
                                            <i class="fa fa-edit blue"></i>
                                        </a>
                                        /
                                        <a href="#" @click="deleteEvse(evse.id)">
                                            <i class="fa fa-trash red"></i>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- /.card-body -->
                        <div class="card-footer">
                            <pagination :data="Evses" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div>
                    <!-- /.card -->
                </div>
            </div>

            <div v-if="!$gate.isAdmin() && !$gate.isIren()">
                <not-found></not-found>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" v-show="!editmode">Create New Evse</h5>
                            <h5 class="modal-title" v-show="editmode">Update Evse Info</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <form @submit.prevent="editmode ? updateEvse() : createEvse()">
                            <div class="modal-body">
                                <div class="form-group">
                                    <label>charging_station</label>
                                    <input v-model="form.charging_station" type="text" name="charging_station"
                                           class="form-control" :class="{ 'is-invalid': form.errors.has('charging_station') }">
                                </div>
                                <div class="form-group">
                                    <label>status</label>
                                    <input v-model="form.status" type="text" name="status"
                                           class="form-control" :class="{ 'is-invalid': form.errors.has('status') }">
                                </div>
                                <div class="form-group">
                                  <label>status_schedule</label>
                                  <input v-model="form.status_schedule" type="text" name="status_schedule"
                                         class="form-control" :class="{ 'is-invalid': form.errors.has('status_schedule') }">
                                </div>
                                <div class="form-group">
                                  <label>capabilities</label>
                                  <input v-model="form.capabilities" type="text" name="capabilities"
                                         class="form-control" :class="{ 'is-invalid': form.errors.has('capabilities') }">
                                </div>
                                <div class="form-group">
                                  <label>connectors</label>
                                  <input v-model="form.connectors" type="text" name="connectors"
                                         class="form-control" :class="{ 'is-invalid': form.errors.has('connectors') }">
                                </div>
                                <div class="form-group">
                                  <label>floor_level</label>
                                  <input v-model="form.floor_level" type="text" name="floor_level"
                                         class="form-control" :class="{ 'is-invalid': form.errors.has('floor_level') }">
                                </div>
                                <div class="form-group">
                                  <label>coordinates</label>
                                  <input v-model="form.coordinates" type="text" name="coordinates"
                                         class="form-control" :class="{ 'is-invalid': form.errors.has('coordinates') }">
                                </div>
                              <div class="form-group">
                                <label>physical_reference</label>
                                <input v-model="form.physical_reference" type="text" name="physical_reference"
                                       class="form-control" :class="{ 'is-invalid': form.errors.has('physical_reference') }">
                              </div>
                              <div class="form-group">
                                <label>directions</label>
                                <input v-model="form.directions" type="text" name="directions"
                                       class="form-control" :class="{ 'is-invalid': form.errors.has('directions') }">
                              </div>
                              <div class="form-group">
                                <label>parking_restrictions</label>
                                <input v-model="form.parking_restrictions" type="text" name="parking_restrictions"
                                       class="form-control" :class="{ 'is-invalid': form.errors.has('parking_restrictions') }">
                              </div>
                              <div class="form-group">
                                <label>images</label>
                                <input v-model="form.images" type="text" name="images"
                                       class="form-control" :class="{ 'is-invalid': form.errors.has('images') }">
                              </div>
                              <div class="form-group">
                                <label>label</label>
                                <input v-model="form.label" type="text" name="label"
                                       class="form-control" :class="{ 'is-invalid': form.errors.has('label') }">
                              </div>

                            </div>
                            <!-- Aggiungi altri campi qui -->
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal">Close</button>
                                <button v-show="editmode" type="submit" class="btn btn-success">Update</button>
                                <button v-show="!editmode" type="submit" class="btn btn-primary">Create</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import { DateTimePicker } from '@progress/kendo-dateinputs-vue-wrapper';
import moment from 'moment';

export default {
    components: {
        'kendo-datetimepicker': DateTimePicker
    },
    data() {
        return {
            editmode: false,
            Evses: {},
            form: new Form({
                id: '',
                created_at: '',
                updated_at: '',
                status: '',
                status_schedule: '',
                capabilities: '',
                connectors: '',
                floor_level: '',
                coordinates: '',
                physical_reference: '',
                directions: '',
                parking_restrictions: '',
                images: '',
                last_updated: '',
                label: '',
                ocpp_evse_id: '',
                charging_station: ''
            }),
            mla: [],
            la: []
        };
    },
    filters: {
        moment: function (date) {
            return moment(date).format('YYYY-MM-DD hh:mm:ss');
        }
    },
    methods: {
      formatDate(dateString) {
        // Create a Date object from the date string
        const date = new Date(dateString);

        // Subtract 2 hours
        date.setHours(date.getHours() - 2);

        // Format the date
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
      },
      editModal(evse){
        this.editmode = true;
        this.form.reset();
        $('#addNew').modal('show');
        this.form.fill(evse);
      },
      newModal(){
        this.editmode = false;
        this.form.reset();
        $('#addNew').modal('show');
      },
      closeModal(){
        $('#addNew').modal('hide');
      },
      loadEvses() {
        axios.get('api/EVSE/getEVSEs').then((response) => {
          this.Evses = response.data;
        }).catch((error) => {
          console.error('Error fetching connectors:', error);
        });
      },
      updateEvse() {
        axios.post('api/EVSE/update/' + this.form.id, this.form)
            .then((response) => {
              $('#addNew').modal('hide');
              Toast.fire({
                icon: 'success',
                title: 'EVSE has been updated'
              });
              this.$Progress.finish();
              this.loadEvses();
            })
            .catch((error) => {
              console.error('Error updating EVSE:', error);
              this.$Progress.fail();
              Toast.fire({
                icon: 'error',
                title: 'Error updating EVSE'
              });
            });
      },
        createEvse() {
          this.form.post('api/EVSE/store')
              .then((response)=>{
                $('#addNew').modal('hide');

                Toast.fire({
                  icon: 'success',
                  title: 'EVSE has been created'
                });

                this.$Progress.finish();
                this.loadEvses();

              })
              .catch(()=>{

                Toast.fire({
                  icon: 'error',
                  title: 'Some error occured! Please try again'
                });
              })
        },
      deleteEvse(id) {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {
            // Send request to the server
            this.form.delete('api/EVSE/delete/'+ id)
                .then(() => {
                  Swal.fire(
                      'Deleted!',
                      'EVSE has been deleted.',
                      'success'
                  );
                  // Optionally, you can fire an event or reload data here
                  this.loadEvses();
                })
                .catch((error) => {
                  // Handle errors
                  Swal.fire(
                      'Failed!',
                      error.response?.data?.message || 'Something went wrong',
                      'warning'
                  );
                });
          }
        });
      }


    },
    created() {
        this.loadEvses();
    }
};
</script>
